import React from 'react';
import styled from 'styled-components';
import { COHORT_PERCENTILE_FILTER_PLACEHOLDER } from '../../../../../utils/builder/cohorts';
import * as BuilderUI from '../../../BuilderUI';
import { SvgIcon } from '../../../../Icon';
import { theme } from '../../../../../styles/theme';
import KubitTooltip from '../../../../KubitTooltip';

const StyledCaretIcon = styled(SvgIcon)`
  width: 16px;
`;

const Container = styled(BuilderUI.BuilderFieldContainer)`
  &:hover {
    cursor: pointer;
    color: ${theme.colors.mainBlue};
  }
`;

const CohortPercentileFilterPlaceholder = () => (
  <KubitTooltip
    content={`between 0 ~ 100 ${COHORT_PERCENTILE_FILTER_PLACEHOLDER}`}
    placement="top-start"
    noOpenDelay={true}
  >
    <Container>
      <BuilderUI.InputLabel>
        {COHORT_PERCENTILE_FILTER_PLACEHOLDER}
      </BuilderUI.InputLabel>
      <StyledCaretIcon
        name="caret-down-fill"
        width={10}
        height={10}
        isActive={true}
      />
    </Container>
  </KubitTooltip>
);

export default CohortPercentileFilterPlaceholder;
